var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.live)?_c('div',{staticClass:"h-100"},[_c('iframe',{staticStyle:{"height":"420px"},attrs:{"src":_vm.src,"width":"100%","height":"420px","frameborder":"0"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }